import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import greenPatternFull from '../assets/images/bottom-pattern copy.png'
import greenPatternHalf from '../assets/images/bottom-pattern.png'

import Header from "../layout/header";
import Agenda from "../components/agenda.component";
import MyMeetings from "../components/my-meetings.component";
import AllMeetings from "../components/all-meetings.component";
import CompanyMeetings from "../components/company-meetings.component";
import AllInvestors from "../components/all-investors.component";

import mediaPartner from '../assets/images/media-partner.jpeg'
import FeedbackComponent from "../components/feedback.component";

import { useStore } from "../App";

const DashboardPage = () => {
    const [searchParams, setSearchParams] = useSearchParams();


//     investor = all meetings
// company = meeting slots

const user = useStore.getState()
const userType = user?.userType ?? false

    const [activeTab, setActiveTab] = useState(userType == "investor" ? 'All Meetings' : 'Meeting Slots');

    // Initialize activeTab from URL on component mount
    useEffect(() => {
        const tabFromUrl = searchParams.get('tab');
        if (tabFromUrl) {
            setActiveTab(tabFromUrl);
        }
    }, [searchParams]);

    // Update URL when activeTab changes
    const handleTabChange = (newTab) => {
        setActiveTab(newTab);
        setSearchParams({ tab: newTab });
    };

    return (
        <div className="dashboard-page" style={{ position: 'relative' }}>
            <Header
                isDashboardPage={true}
                isDetailPage={false}
                activeTab={activeTab}
                setActiveTab={handleTabChange} // Use the new handler
            />

            <div className="container mt-4">
                {activeTab === "All Meetings" && <AllMeetings />}
                {activeTab === "My Meetings" && <MyMeetings />}
                {activeTab === "Meeting Slots" && <CompanyMeetings />}
                {activeTab === "All Investors" && <AllInvestors />}
                {activeTab === "Feedback" && <FeedbackComponent />}

                <span className="d-none d-sm-block pb-3">
                    <div className="row">
                        
                        <div className="col-12 d-flex justify-content-end">
                            <img className="green-pattern" src={greenPatternFull} alt="" />
                        </div>
                    </div>

                </span>

                <span className="d-block d-sm-none">

                    <img className="green-pattern" src={greenPatternHalf} alt="" />

                    {/* <span style={{ position: 'absolute', bottom: 0, left: '10px', marginBottom: '10px', fontWeight: 'bold' }}>Media Partner | <img style={{ height: '30px' }} src={mediaPartner} alt="" /></span> */}

                </span>
            </div>


        </div>
    );
};

export default DashboardPage;